export default "__VITE_ASSET__DNO_pvm4__"